import React, { FunctionComponent, useEffect, useState } from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectProps,
  Tooltip
} from "@material-ui/core";
import { PriceUnit } from "../../models/Market";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../store";
import { thunkFetchCurrentMarket } from "../../store/markets/actions";

interface PriceUnitSelectProps extends Omit<SelectProps, "loading"> {
  label?: string;
  onSelected?: (value: PriceUnit) => void;
  variant?: "filled" | "outlined" | "standard";
  value?: string;
  error?: boolean;
  disabled?: boolean;
}

export const PriceUnitSelect: FunctionComponent<PriceUnitSelectProps> = ({
  label = "PriceUnit",
  onSelected,
  onChange,
  variant = "standard",
  value = [],
  error = false,
  disabled = false,
  ...props
}) => {
  const dispatch = useDispatch();
  const priceUnits =
    useSelector<AppState, ReadonlyArray<PriceUnit>>(
      s => s.currentMarket.priceUnits
    ) || [];
  const [state, setState] = useState<ReadonlyArray<PriceUnit>>([]);

  const handleChange = (
    event: React.ChangeEvent<{ name?: string; value: unknown }>,
    child: React.ReactNode
  ) => {
    if (onSelected) {
      let priceUnit = state.find(p => p.unit === event.target.value);

      if (priceUnit) {
        onSelected(priceUnit);
      }
    }
    if (onChange) {
      onChange(event, child);
    }
  };

  useEffect(() => {
    // load if not loaded
    if (!priceUnits || !priceUnits.length) {
      dispatch(thunkFetchCurrentMarket());
    }
  }, []);

  useEffect(() => {
    return setState([...priceUnits].sort((a, b) => (a.unit > b.unit ? 1 : -1)));
  }, [priceUnits]);

  return (
    <FormControl
      variant={variant}
      className={props.className}
      error={error}
      style={props.style}
    >
      <InputLabel
        id="cluster-select-label"
        style={
          variant === "outlined"
            ? {
                backgroundColor: "#fff",
                paddingLeft: "0.5rem",
                paddingRight: "0.5rem"
              }
            : undefined
        }
      >
        {label}
      </InputLabel>
      <Tooltip
        title={
          disabled
            ? "Products that have weight in the barcode will be sold per kg"
            : ""
        }
      >
        <Select
          disabled={disabled}
          value={value}
          onChange={handleChange}
          labelId="PriceUnit-select-label"
          id="PriceUnit-select"
          autoWidth={true}
        >
          {state &&
            state.length > 0 &&
            state.map(p => (
              <MenuItem key={p.unit} value={p.unit}>
                {p.currencySymbol}/{p.unit}
              </MenuItem>
            ))}
        </Select>
      </Tooltip>
    </FormControl>
  );
};
